import Vue from 'vue'
import Router from 'vue-router'

import About from '@/views/About'
import Archive from '@/views/Archive'
import Committee from '@/views/Committee'
import Conduct from '@/views/Conduct'
import ConvinceBoss from '@/views/ConvinceBoss'
import Info from '@/views/Info'
import LandingPage from '@/views/LandingPage'
import Lineup from '@/views/Lineup'
import MySchedule from '@/views/MySchedule'
import NotFound from '@/views/NotFound'
import OredevPlusV2 from '@/views/OredevPlusV2'
import PartnerInfo from '@/views/PartnerInfo'
import Partnership from '@/views/Partnership'
import Privacy from '@/views/Privacy'
import Program from '@/views/Program'
import SpeakerInfo from '@/views/SpeakerInfo'
import Tickets from '@/views/Tickets'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage
    },
    {
      path: '/tickets',
      name: 'Tickets',
      component: Tickets
    },
    /* {
      path: '/line-up/:speakerId?',
      name: 'Lineup',
      component: Lineup,
    },
    {
      path: '/program',
      name: 'Program',
      component: Program,
    }, */
    {
      path: '/info',
      name: 'Info',
      component: Info
    },
    /* {
      path: '/my-schedule/:id?',
      name: 'MySchedule',
      component: MySchedule
    }, */
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/code-of-conduct',
      name: 'Conduct',
      component: Conduct
    },
    {
      path: '/archive',
      name: 'Archive',
      component: Archive
    },
    {
      path: '/committee',
      name: 'Committee',
      component: Committee
    },
    {
      path: '/partners',
      name: 'Partnership',
      component: Partnership
    },
    {
      path: '/privacy-policy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/convince-your-boss',
      name: 'ConvinceBoss',
      component: ConvinceBoss
    },
    /* {
      path: '/speaker-info',
      name: 'SpeakerInfo',
      component: SpeakerInfo,
    },
    {
      path: '/partner-info',
      name: 'PartnerInfo',
      component: PartnerInfo,
    }, */
    /*{
      path: '/oredev-plus',
      name: 'OredevPlus',
      component: OredevPlusV2
    }, */
    {
      // will match everything
      path: '/*',
      component: NotFound
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    const scrollToTopPages = [
      "About",
      "Conduct",
      "Archive",
      "Committee",
      "Partnership",
      "Privacy",
      "ConvinceBoss"
    ]
    //https://router.vuejs.org/guide/advanced/scroll-behavior.html

    // 1. Handle #hash scrolling with delay
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ selector: to.hash });
        }, 300);
      });
    }

    // 2. Don't reset scroll if navigating within Lineup
    if (from.name === "Lineup" && to.name === "Lineup") {
      return;
    }

    // 3. Restore saved scroll position (e.g. back/forward)
    if (savedPosition) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(savedPosition);
        }, 300);
      });
    }

    // 4. Scroll to top for footer pages
    if (scrollToTopPages.includes(to.name)) {
      return delayedScrollTop();
    }

    // 5. Fallback: scroll to top
    return delayedScrollTop();

    // Helper for scroll delay
    function delayedScrollTop() {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 });
        }, 300);
      });
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js